define.alias("shared/components/shared/ui/mobile-redirect-prompt", "preview-grid/components/shared/ui/mobile-redirect-prompt");